module.exports = __webpack_public_path__ + "static/002-b73b952c1972dcb54a019a95cc97c007.jpeg";